export default __webpack_public_path__ + "static/media/twitterLogo.05408a2b.svg";